/**
 * Formats a date string to DD/MM/YYYY format.
 * Works with YYYY-MM-DD, ISO timestamps, and date strings.
 * Returns the formatted date or the original string if invalid.
 */
export const formatDateDMY = (dateStr) => {
  if (!dateStr) return "-";

  // If already in DD/MM/YYYY format, return as is
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    return dateStr;
  }

  // Handle YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }

  // Handle standard date object parsing (e.g. ISO string)
  try {
    const date = new Date(dateStr);
    if (!isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  } catch (e) {
    // Ignore and return original
  }

  return dateStr;
};
